import {useEffect, useState} from 'react';
import {useFormContext} from 'react-hook-form';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import makeAnimated from 'react-select/animated';

//https://react-select.com/
 
const Dropdown = ({
                      className = '',
                      name,
                      label,
                      required,
                      defaultValue,
                      styles,
                      single,
                      options = [],
                      multiValueStyle,
                      isSearchable,
                      creatable,
                      invisible,
                      ...rest
                  }) => {
    const [value, setValue] = useState();
    const methods = useFormContext();
    const animatedComponents = makeAnimated();

    const validationRules = {
        required: required ? "Toto pole je povinné" : false,
      };

    const onChange = (selectedValues) => {
        setValue(selectedValues)
        if (methods&&!single) {
            methods.setValue(name, selectedValues)
        } 
        if (rest.onChange) {
            rest.onChange(selectedValues);
        }

    }
    
    useEffect(()=>{
        if (defaultValue) onChange(defaultValue);
    }, [])

    const fixedStyles = {
        control: () =>
            (methods && methods.formState.errors[name] ? " border-red-500" : '') +
            " bg-white border-b border-[#CFCFCF] hover:cursor-pointer",
        placeholder: () => ("text-gray-500 py-0.5"),
        input: () => "pl-1",
        valueContainer: () => "gap-1",
        singleValue: () => "leading-7 ml-1",
        multiValue: () => {
            if (multiValueStyle) return (multiValueStyle)
            else {
                return ("bg-base-color rounded text-white items-center py-0.5 pl-2 pr-1 gap-1.5 hover:cursor-pointer")
            }
        },
        indicatorsContainer: () => "p-1 gap-1",
        indicatorSeparator: () => "hidden",
        menu: () => "p-1 mt-2 border border-[#CFCFCF] bg-white z-20",
        menuPortal: () => "!z-[100]", 
    }

    return (
        <div className={'superdropdown ' + className} style={invisible?{display:'none'}:{}}>
            {label && <p>{label} {required && <sup>*</sup>}</p>}
            {creatable ? <CreatableSelect 
                isMulti 
                options={options}
                {...methods && !single && methods.register(name, validationRules)}
                {...rest}
                value={value}
                defaultValue
                name={name}
                unstyled
                styles={styles}
                components={animatedComponents}
                isSearchable={isSearchable}
                menuPortalTarget={document.body}
                onChange={onChange}
                classNames={{
                    ...fixedStyles,
                    option: ({isSelected}) => (
                        "hover:cursor-pointer hover:text-white hover:bg-base-color px-3 py-2 text-gray-500 z-20 " +
                        (isSelected ? " bg-base-color text-white " : "")
                    ),
                    multiValueRemove: ({data}) => data.isFixed ? '!hidden' :'',
                }}
                menuPosition='fixed'
            /> : <Select
                options={options}
                {...methods && !single && methods.register(name, validationRules)}
                {...rest}
                value={value}
                defaultValue
                name={name}
                unstyled
                styles={styles}
                components={animatedComponents}
                isSearchable={isSearchable}
                isClearable={required?false:true}
                onChange={onChange}
                menuPortalTarget={document.body}
                classNames={{
                    ...fixedStyles,
                    option: ({isSelected}) => (
                        "hover:cursor-pointer hover:text-white hover:bg-base-color px-3 py-2 text-gray-500 z-20 " +
                        (isSelected ? " bg-base-color text-white " : "")
                    ),
                    multiValueRemove: ({data}) => data.isFixed ? '!hidden' :'',
                }}
                menuPosition='fixed'
            />}
            {methods && methods.formState.errors[name] && !single &&
                <p className='err'>{methods.formState.errors[name]?.message}</p>}
        </div>
    )
}

export default Dropdown;

